//
// NINJA FORMS - ANALYTICS / TAG MANAGER TRACKING
//

document.addEventListener('DOMContentLoaded', function () {

    // Check if Ninja Forms is enabled
    var ninjaFormsEnabled = typeof window['Marionette'] !== 'undefined';

    // Check if the theme actually wants to use this functionality
    var useNinjaFormsTracking = document.querySelector('script[data-ga-nf-tracking]');

    if (ninjaFormsEnabled && useNinjaFormsTracking) {

        // Create a Ninja Forms valid Controller for our logic
        var mySubmitController = Marionette.Object.extend({

            initialize: function () {
                // This action is run after the form has been validated and just before it sends the data to the server to be saved
                this.listenTo(Backbone.Radio.channel('forms'), 'after:submitValidation', this.submitValidation);
            },

            submitValidation: function (data) {
                var usingGTM = document.querySelector('script[data-gtm]');
                var usingGA = document.querySelector('script[data-ga]');
                var formName = data.attributes.title;

                // Google Tag Manager (GTM)
                if (usingGTM) {
                    dataLayer.push({
                        event: 'form_submit',
                        form_name: formName,
                    });
                } else if (usingGA) {
                    // Google Analytics (direct; no GTM container)
                    if (usingGA.dataset.ga === 'UA') {
                        // Universal Analytics
                        gtag('event', 'form_submit', {
                            event_category: 'Form',
                            event_label: formName
                        });
                    } else {
                        // Google Analytics 4
                        gtag('event', 'form_submit', {
                            'form_name': formName
                        });
                    }
                }

            },
        });

        // Instantiate our custom field's controller, defined above.
        new mySubmitController();
    }
});